import React, { useEffect, useState } from "react";
/*import Login from './pages/Login';
import { auth } from './firebase';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout, selectUser } from './features/userSlice';*/
import { Route } from "wouter";
import { shuffle } from "lodash";

import colors from "./Data/Colors/Colors";
//  Components
import Gallery from "./components/Gallery/Gallery";
import Header from "./components/Sidebar/Header";
import Genres from "./components/Genres/Genres";
import Techno from "./components/Genres/Techno/Techno";
import Electronic from "./components/Genres/Electronic/Electronic";
import DeepTech from "./components/Genres/DeepTech/DeepTech";
import TechHouse from "./components/Genres/TechHouse/TechHouse";
import Tropical from "./components/Genres/TropicalHouse/Tropical";
import DeepHouse from "./components/Genres/DeepHouse/DeepHouse";
import SoundCloud from "./components/SoundCloud/SoundCloud";
import Radio from "./components/Radio/Radio";
import DjSets from "./components/DjSets/DjSets";
import SidebarLayout from "./components/Sidebar/SidebarLayout";

function App() {
  //const user = useSelector(selectUser);
  const [color, setColor] = useState(null);
  //const dispatch = useDispatch();

  /*useEffect(() => {
    const unsuscribe = auth.onAuthStateChanged(userAuth => {
      if (userAuth) {
        //logged in
        dispatch(
          login({
            uid: userAuth.uid,
            email: userAuth.email,
          })
        );
      } else {
        //logged out
        dispatch(logout());
      }
    });

    return unsuscribe;
  }, [dispatch]);*/

  // COLORES DE LA CABECERA CENTER
  useEffect(() => {
    setColor(shuffle(colors).pop());
  }, []);

  return (
    <div className="overflow-hidden h-screen background">
      <Header />

      <main className="flex">
        {/* SIDEBAR */}

        <SidebarLayout />
        {/* CENTER */}
        <div
          className={`overflow-y-scroll scrollbar-hide mt-5 mx-auto w-full
                bg-gradient-to-t to-transparent ${color}`}
        >
          <section className={`items-center space-x-7 text-white  h-screen`}>
            {/* GALLERY */}
            <Route component={Gallery} path="/" />

            {/* GENRES */}
            <Route component={Genres} path="/genres" />
            <Route component={Techno} path="/genres/melodic-house&techno" />
            <Route component={Electronic} path="/genres/electronic&downtempo" />
            <Route component={DeepTech} path="/genres/minimal&deep-tech" />
            <Route component={TechHouse} path="/genres/tech-house" />
            <Route component={Tropical} path="/genres/tropical-house" />
            <Route component={DeepHouse} path="/genres/house&deep-house" />

            {/* SOUNDCLOUD */}
            <Route component={SoundCloud} path="/soundcloud" />

            {/* DJ SETS */}
            <Route component={DjSets} path="/dj-sets" />
            {/*<Route component={Residentes} path="/residents" />
                <Route component={Charts} path="/charts" />*/}
          </section>
        </div>
      </main>

      {/* PLAYER */}
      <footer className="sticky bottom-0 z-10">
        <Radio />
      </footer>
    </div>
  );
}

export default App;
